import _typeof from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { VueCropper } from "vue-cropper";
export default {
  name: "cropperImg",
  components: {
    VueCropper: VueCropper
  },
  props: {
    autoCropWidth: {
      type: Number,
      required: true,
      default: 60
    },
    autoCropHeight: {
      type: Number,
      required: true,
      default: 60
    }
  },
  data: function data() {
    return {
      isHasCrop: true,
      cutType: 1,
      show: false,
      loading: false,
      filename: "",
      option: {
        img: "",
        outputSize: 1,
        //剪切后的图片质量（0.1-1）
        full: false,
        //输出原图比例截图 props名full
        outputType: "png",
        canMove: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 150,
        autoCropHeight: 150,
        fixedBox: true
      }
    };
  },
  computed: {},
  methods: {
    closeDialog: function closeDialog() {
      this.show = false;
    },
    //上传图片（点击上传按钮）
    finish: function finish() {
      var _this = this;

      this.$refs.cropper.getCropData(function (data) {
        _this.$emit("uploadHttp", _this.base64ToFile(data, _this.filename || "aaa.png"));
      });
    },
    base64ToFile: function base64ToFile(Base64, filename) {
      var arr = Base64.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {
        type: mime
      });
    },
    uploadImg: function uploadImg(file) {
      var _this2 = this;

      this.filename = file.name;
      this.show = true;
      this.$nextTick(function () {
        var reader = new FileReader();

        reader.onload = function (e) {
          var data;

          if (_typeof(e.target.result) === "object") {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]));
          } else {
            data = e.target.result;
          }

          _this2.option.img = data;
        };

        reader.readAsDataURL(file);
      });
    }
  },
  watch: {
    show: function show(val) {
      if (!val) {
        this.cutType = 1;
      }
    },
    cutType: function cutType() {
      var _this3 = this;

      this.isHasCrop = false;
      this.$nextTick(function () {
        _this3.isHasCrop = true;
      });
    }
  },
  filters: {}
};